import {Container} from "pixi.js";

export interface IPixiDraggable extends Container {
  dragged?: boolean;
  dragging?: boolean;
}

export enum EllipseOffset {
  toEdgeRaw = 'toEdgeRaw',
  toEdgeRounded = 'toEdgeRounded',
  toEdgeCeil = 'toEdgeCeil',
  toEdgeFloor = 'toEdgeFloor'
}


export enum BasicShapes {
  ellipse = 'ellipse',
  rect = 'rect',
  roundedRect = 'roundedRect',
}

export enum FontClr {
  black = 'black',
  grey = 'grey',
  grey2 = 'grey2',
  white = 'white',
  red = 'red',
}

export enum FontWt {
  normal = 'normal',
  semiBold = 'semiBold',
  bold = 'bold',
}
